// extracted by mini-css-extract-plugin
export default {"root":"TeamMember_root__kVBrj","photo":"TeamMember_photo__2gd0n","name":"TeamMember_name__wUKnM","position":"TeamMember_position__biYG-"};